export default __webpack_public_path__ + "static/cardsRowImg2-687cf65a741a6ece47d62d9d0cf6f73a.png";